export interface DecodedToken {
  email?: string;
  email_verified?: boolean;
  exp: number; // seconds since epoch
  [key: string]: unknown;
}

function base64UrlDecode(input: string): string {
  const padded = input.replace(/-/g, '+').replace(/_/g, '/');
  // atob exists in both the browser and the jsdom/node test environment.
  // eslint-disable-next-line no-undef
  return decodeURIComponent(
    atob(padded)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
}

export function decodeJwt(token: string): DecodedToken {
  const parts = token.split('.');
  if (parts.length < 2) {
    throw new Error('Malformed JWT: expected at least two segments');
  }
  const payload = JSON.parse(base64UrlDecode(parts[1]));
  if (typeof payload.exp !== 'number') {
    throw new Error('Malformed JWT: missing numeric exp');
  }
  return payload as DecodedToken;
}
